export enum SbomFormat {
  Cyclone = 'cyclonedx',
  SPDX = 'spdx',
  SPDXV3 = 'spdxv3'
}

export enum SbomType {
  Application = 'applications',
  Server = 'servers'
}
